import React from "react";
import { FiMail, FiMapPin, FiArrowRight } from "react-icons/fi";

const CleanFooter = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { label: "Airport Transfers", href: "#airport" },
      { label: "Corporate Travel", href: "#corporate" },
      { label: "City Tours", href: "#tours" },
      { label: "Hourly Rentals", href: "#hourly" },
    ],
    company: [
      { label: "About Us", href: "/about" },
      { label: "Careers", href: "/careers" },
    ],
    legal: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Client Agreement", href: "/agreement" },
      { label: "Cookie Policy", href: "/cookies" },
    ],
  };

  return (
    <footer className="clean-footer">
      <div className="footer-cta">
        <div className="clean-container">
          <div className="cta-content-wrapper">
            <div className="cta-text">
              <h2 className="cta-heading">Ready for your next journey?</h2>
              <p className="cta-subheading">
                Join thousands of satisfied riders worldwide with GlobeCab
              </p>
            </div>
            <div className="cta-actions">
              <a href="mailto:bookings@globecab.com" className="cta-btn-primary">
                Book Now
                <FiArrowRight />
              </a>
            </div>
          </div>

          <div className="cta-stats">
            <div className="cta-stat">
              <span className="cta-stat-value">100K+</span>
              <span className="cta-stat-label">Rides Monthly</span>
            </div>
            <div className="cta-stat">
              <span className="cta-stat-value">40</span>
              <span className="cta-stat-label">Countries</span>
            </div>
            <div className="cta-stat">
              <span className="cta-stat-value">50K+</span>
              <span className="cta-stat-label">Drivers</span>
            </div>
            <div className="cta-stat">
              <span className="cta-stat-value">4.8/5</span>
              <span className="cta-stat-label">Rating</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-main">
        <div className="clean-container">
          <div className="footer-grid">
            <div className="footer-column footer-brand">
              <div className="footer-logo">
                Globe<span>Cab</span>
              </div>
              <p className="footer-description">
                The world's most reliable taxi service, providing safe and comfortable 
                transportation across 150+ cities globally.
              </p>
              <div className="footer-contact">
                <a href="mailto:bookings@globecab.com" className="contact-item">
                  <FiMail />
                  <span>bookings@globecab.com</span>
                </a>
                <div className="contact-item">
                  <FiMapPin />
                  <span>London • New York • Tokyo • Dubai</span>
                </div>
              </div>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-links">
                {footerLinks.services.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-links">
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-heading">Legal</h4>
              <ul className="footer-links">
                {footerLinks.legal.map((link, index) => (
                  <li key={index}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="clean-container">
          <div className="bottom-content">
            <div className="copyright">
              © {currentYear} GlobeCab International. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CleanFooter;